
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import Step from '@/components/step.vue';
	import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
	import AddressSelect from '@/components/address-select.vue'
	import Dialog from '@/components/dialog.vue';
	import receiptView from './components/receipt-view.vue';
	
	import {
		orderInfo,
		lookExpress,
		addresssmartparse,
		ordereditReceiveAddress,
		ordereditCustomerServiceRemark
	} from '@/api/order'
	import {imgHost} from "@/utils/config"

	@Component({
		name: 'order-detail',
		components: {
			Step,
			PageFooter,
			CollapseItem,
			AddressSelect,
			'slz-dialog': Dialog,
			receiptView
		}
	})
	export default class OrderDetail extends Vue {
		private imgurl = imgHost
		private orderId = this.$route.query.id || 0;
		private stepList = ['提交订单', '订单已审核', '商家发货', '确认收货'];
		private formData: any = {}
		private address = ''
		
		private activeStep = 0


		private logisticsShow = false
		private logisticsitem:any = {}
		private logisticsmsg:any = [
			// {AcceptTime:'2022年4月19日16:44:43',AcceptStation:'发撒发gas嘎嘎嘎嘎',color:'#409eff'},
			// {AcceptTime:'2022年4月19日16:44:43',AcceptStation:'发撒发gas嘎嘎嘎嘎'},
			// {AcceptTime:'2022年4月19日16:44:43',AcceptStation:'发撒发gas嘎嘎嘎嘎'},
			// {AcceptTime:'2022年4月19日16:44:43',AcceptStation:'发撒发gas嘎嘎嘎嘎'},
			// {AcceptTime:'2022年4月19日16:44:43',AcceptStation:'发撒发gas嘎嘎嘎嘎'},
		]
		private identifyAddress = '';
		
		private receiptShow = false
		private receiptOrderNo = this.$route.query.id || 0;

		private itemlist:any = []
		private detailloading = false

		private mounted() {
			this.getInfo()
		}


		private async savenote(){
			try{
				let res = await ordereditCustomerServiceRemark({
					OrderNo:this.orderId,
					CustomerServiceRemark:this.formData.CustomerServiceRemark
				})
				if(res.IsSuccess){
					this.$message.success('保存成功')
					this.getInfo()
				}
			}finally{
				//
			}
		}
		private chooseNo(e){
			this.logisticsitem = e
			this.getlogistics(this.logisticsitem)
		}
		private handleClick() {}

		private async save(){
			if(!this.formData.ReceiveName){
				this.$message.error('请完善收件人信息')
				return
			}
			if(!this.formData.ReceivePhone){
				this.$message.error('请完善收件手机号')
				return
			}
			if(!this.formData.ReceiveProvince||!this.formData.ReceiveCity||!this.formData.ReceiveArea||!this.formData.ReceiveAddress){
				this.$message.error('请完善收货地址')
				return
			}

			try{
				let res = await ordereditReceiveAddress({
					OrderNo:this.formData.OrderNo,
					ReceiveName:this.formData.ReceiveName,
					ReceivePhone:this.formData.ReceivePhone,
					ReceiveProvince:this.formData.ReceiveProvince,
					ReceiveCity:this.formData.ReceiveCity,
					ReceiveArea:this.formData.ReceiveArea,
					ReceiveAddress:this.formData.ReceiveAddress,
					CustomerRemark:this.formData.CustomerRemark
				})
				if(res.IsSuccess){
					this.$message.success('保存成功')
					this.getInfo()
				}
			}finally{
				//
			}
		}
		private clearaddress(){
			if(this.formData.OrderState!=0){
				return 
			}
			this.identifyAddress = ''
		}

		private async toidentify(){
			if(this.formData.OrderState!=0){
				return 
			}
			if(!this.identifyAddress){
				this.$message.error('请输入内容')
				return
			}
			try{
				let res = await addresssmartparse({
					Address:this.identifyAddress
				})
				if(res.IsSuccess){
					// console.log(res)
					this.formData.ReceiveProvince = res.Result.Province
					this.formData.ReceiveCity = res.Result.City
					this.formData.ReceiveArea = res.Result.Area
					this.formData.ReceiveAddress = res.Result.Address

					this.formData.ReceiveName = res.Result.Name||this.formData.ReceiveName
					this.formData.ReceivePhone = res.Result.Phone||this.formData.ReceivePhone
				}
			}finally{
				//
			}
		}

		private changeAddress(list: any) {
			this.formData.ReceiveProvince = list[0]
			this.formData.ReceiveCity = list[1]
			this.formData.ReceiveArea = list[2]
		}

		private toBack() {
			this.$router.go(-1)
		}

		private looklogistics(item,index,itemlist){
			this.logisticsShow = true
			this.logisticsitem = item
			this.itemlist = itemlist
			// console.log(item,this.formData)
			this.getlogistics(item)
		}
		private looklogistics2(item,index){
			this.logisticsShow = true
			this.itemlist = item
			this.logisticsitem = item[0]
			this.getlogistics(this.logisticsitem)
		}

		private async getlogistics(data){
			try{
				this.logisticsmsg = []
				this.detailloading = true
				let item = await data
				let res = await lookExpress({
					ExpressId:item.ExpressId,
					ExpressNo:item.ExpressNo,
					ReceivePhone:this.formData.ReceivePhone
				})
				if(res.IsSuccess){
					this.logisticsmsg = res.Result.sort((a,b)=>{
            return -1
          }).map((item, index)=>{
						item.color = index===0 ? '#0067cc':'#999';
						return item;
					})
				}
			}finally{
				this.detailloading = false
			}
		}

		// 获取订单详情
		private async getInfo() {
			try {
				const res: any = await orderInfo({
					OrderNo: this.orderId
				})
				this.formData = res.Result;
				this.formData.RealNameMsg = this.formData.RealName + '   ' + this.formData.IDCard
				this.formData.OrderMoneyValue = this.formData.OrderMoney
				if(this.formData.ActivityMarkdownMoney>0){
					this.formData.OrderMoneyValue+='   ' + '[满减优惠]共减'+this.formData.ActivityMarkdownMoney+'元'
				}
				// this.address = res.Result.ReceiveProvince+res.Result.ReceiveCity+res.Result.ReceiveArea+res.Result.ReceiveAddress
				if (res.Result.OrderState === 10){
					this.activeStep = 1;
				}
				if (res.Result.OrderState === 20){
					this.activeStep = 2;
				}
				if (res.Result.OrderState === 30){
					this.activeStep = 3;
				}
				
			} catch (e) {
				console.log(e)
			}
		}
	}
